import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import TarjetaMuro from './TarjetaMuro'; 

const BACKEND_URL = '';

function Home({ setGlobalConfig }) {
    const { slug } = useParams(); 
    const [config, setConfig] = useState(null); 
    const [loadingConfig, setLoadingConfig] = useState(true);
    const [obituarios, setObituarios] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [todosDifuntos, setTodosDifuntos] = useState([]); 
    const [showSearch, setShowSearch] = useState(false);
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
    const [funerarias, setFunerarias] = useState([]);
    const navigate = useNavigate(); 
    
    // ESTE ES EL BLOQUEO ANTIBUCLE
    const cargadoRef = useRef(false);

    useEffect(() => {
        if (!slug || cargadoRef.current) return;
        cargadoRef.current = true; 

        const cargarDatos = async () => {
            try {
                // Cargamos configuración y difuntos en paralelo
                const [resDifuntos, resConfig] = await Promise.allSettled([
                    axios.get('/api/v1/difuntos/index.json'),
                    axios.get(`/api/public/config/${slug}/index.json`)
                ]);

                if (resDifuntos.status === 'fulfilled') {
                    const datos = Array.isArray(resDifuntos.value.data) ? resDifuntos.value.data : [];
                    setTodosDifuntos(datos);
                    setObituarios(datos.slice(0, 4));
                }

                if (resConfig.status === 'fulfilled') {
                    const data = resConfig.value.data;
                    setConfig(data);
                    if (setGlobalConfig) setGlobalConfig(data);
                    setFunerarias(data.funerarias || []);
                }
            } catch (err) {
                console.error("Error detenido para evitar bucle infinito");
            } finally {
                setLoadingConfig(false);
                setLoading(false);
            }
        };

        cargarDatos();
    }, [slug, setGlobalConfig]);

    const primaryColor = config?.color_principal || 'rgba(46, 125, 50, 0.8)';
    const webTitle = config?.titulo_web || (slug ? `Cementerio de ${slug.charAt(0).toUpperCase() + slug.slice(1)}` : 'Cargando...');
    const sideBoxStyle = { backgroundColor: 'rgba(255, 255, 255, 0.9)', padding: '15px', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' };

    // CÁMBIALO PARA QUE QUEDE ASÍ (LIMPIO Y FUNCIONAL)
const sliderImages = ['/slide-1.png', '/slide-2.png', '/slide-3.png', '/slide-4.png'];

    const handleSearch = (e) => {
        const texto = e.target.value;
        setTerminoBusqueda(texto);

        if (texto.length > 1) {
            const searchTerms = texto.toLowerCase().trim().split(/\s+/);
            const filtrados = todosDifuntos.filter(d => {
                const nombre = d.nombre || '';
                const apellidos = d.apellidos || '';
                const fullName = `${nombre} ${apellidos}`.toLowerCase();
                return searchTerms.every(term => fullName.includes(term));
            }).sort((a, b) => {
                const nameA = `${a.nombre} ${a.apellidos}`;
                const nameB = `${b.nombre} ${b.apellidos}`;
                return nameA.localeCompare(nameB);
            }).slice(0, 10);
            setResultadosBusqueda(filtrados);
        } else { 
            setResultadosBusqueda([]); 
        }
    };

    if (loadingConfig) return <p style={{textAlign: 'center', padding: '50px'}}>Iniciando Demo...</p>;

    return (
        <div style={{ 
            padding: '20px', 
            maxWidth: '100vw',             
            margin: '0 auto', 
            minHeight: '100vh',             
            backgroundImage: 'url(/cementerio-fondo.jpg.jpeg)',
            backgroundSize: 'cover',       
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed', 
            backgroundColor: '#eee' 
        }}>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                backgroundColor: primaryColor, 
                padding: '10px 20px', 
                borderRadius: '8px', 
                marginBottom: '30px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.3)' 
            }}>
                <h2 style={{ 
                    margin: 0, color: '#fff', textTransform: 'uppercase', 
                    letterSpacing: '1px', textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                    fontSize: '1.5em'
                }}>
                    {webTitle} 
                </h2>
            </div>

            <div style={{ 
                display: 'grid', 
                gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : '1.4fr 2.2fr 1.4fr', 
                gap: '30px', 
                alignItems: 'start' 
            }}>
                <div>
                    <div style={{ ...sideBoxStyle, marginBottom: '20px' }}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#555', borderBottom: '1px solid #eee' }}>📍 Plano General</h4>
                        <img 
                            src={config?.id ? `/uploads/clientes/${config.id}/general/plano.jpg` : '/escudo-defecto.png'} 
                            alt="Plano"
                            style={{ width: '100%', height: 'auto', borderRadius: '8px' }} 
                            onError={(e) => { e.target.onerror = null; e.target.src = "/escudo-defecto.png"; }}
                        />
                    </div>
                    <div style={sideBoxStyle}>
                        <h4 style={{ margin: '0 0 10px 0', color: '#2E7D32' }}>Horario</h4>
                        <p style={{ margin: 0, fontSize: '0.9em' }}><strong>VERANO:</strong> {config?.horario_verano || "09:00 - 21:00"}</p>
                        <p style={{ margin: '5px 0 0 0', fontSize: '0.9em' }}><strong>INVIERNO:</strong> {config?.horario_invierno || "09:00 - 19:00"}</p>
                    </div>

                    {funerarias.length > 0 && (
                        <div style={{ ...sideBoxStyle, marginTop: '40px', padding: '25px' }}>
                            <h4 style={{ margin: '0 0 20px 0', color: '#2c3e50', borderBottom: '2px solid #eee', paddingBottom: '12px' }}>
                                🤝 Servicios Funerarios
                            </h4>
                            {funerarias.map(f => (
                                <Link key={f.id} to={`/${slug}/funeraria/${f.funeraria_slug}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block', marginBottom: '20px' }}>
                                    <div style={{ padding: '15px', borderRadius: '12px', backgroundColor: '#fff', border: '1px solid #eee', textAlign: 'center' }}>
                                        {f.logo_path && <img src={f.logo_path} alt="Logo" style={{ width: '60px', marginBottom: '10px' }} />}
                                        <div style={{ fontWeight: 'bold' }}>{f.nombre_visible}</div>
                                        <div style={{ color: '#b91c1c', fontSize: '0.9em' }}>📞 {f.configuracion_estetica?.telefono}</div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
                    
                <div>
                    <div style={{ backgroundColor: 'rgba(255,255,255,0.95)', padding: '20px', borderRadius: '12px', marginBottom: '25px', textAlign:'center', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                        <h2 style={{ margin: 0, color: '#444', fontSize:'1.5em' }}>📢 Últimas Defunciones</h2>
                    </div>
                    {loading && <p style={{textAlign:'center', color:'white'}}>Cargando...</p>}
                    <div style={{ maxHeight: '800px', overflowY: 'auto' }}>
                        {obituarios.map(post => <TarjetaMuro key={post.id || post.difunto_id} post={post} config={config} />)}
                    </div>
                </div>

                <div>
                    <button onClick={() => setShowSearch(!showSearch)} style={{ width: '100%', padding: '15px', backgroundColor: '#2E7D32', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', marginBottom: '15px' }}>
                        {showSearch ? 'Ocultar Buscador' : '🔍 Buscar Nicho'}
                    </button>
                    {showSearch && (
                        <div style={{ ...sideBoxStyle, marginBottom: '20px' }}>
                            <input type="text" placeholder="Nombre..." value={terminoBusqueda} onChange={handleSearch} style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }} />
                            {resultadosBusqueda.map(r => (
    <div 
        key={r.id} 
        onClick={() => window.open('/captura-ficha-demo.png', '_blank')} 
        style={{ textDecoration: 'none', color: '#333', padding: '10px', display: 'block', borderBottom: '1px solid #eee', cursor: 'pointer' }}
    >
        👤 {r.nombre} {r.apellidos}
    </div>
))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Home;